import { Button } from "~/components/Button";
import { ListingGroup } from "~/components/layout/ListingGroup";
import { Page } from "~/components/layout/Page";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { Can } from "~/components/permission/Can";
import { Only } from "~/components/permission/Only";
import { useProfile } from "~/providers/ProfileProvider";

export default function InstructionsIndex() {
    const { instructions } = useProfile();

    return (
        <Page spacer>
            <SectionHeader
                title="Emergency instructions"
                icon="ambulance"
                button={() => (
                    <Can ability="update" section="profile">
                        <Button
                            title="Add instruction"
                            variant="primary"
                            size="lg"
                            href={{ pathname: "/health-profile/emergency-instructions/create" }}
                        />
                    </Can>
                )}
            >
                Document any instructions in case of an emergency.
            </SectionHeader>
            <Only when={instructions.length}>
                <ListingGroup
                    items={instructions.map(({ id, description, photograph_ids }) => ({
                        key: id,
                        title: description,
                        href: {
                            pathname: "/health-profile/emergency-instructions/[id]/show",
                            params: { id },
                        },
                        subtitle: photograph_ids.length ? "Files(s) attached" : null,
                    }))}
                />
            </Only>
        </Page>
    );
}
